module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com.ff918a2c.svg";